import { render, staticRenderFns } from "./CustomerDocumentationVerification.vue?vue&type=template&id=7b92742d&scoped=true&"
import script from "./CustomerDocumentationVerification.vue?vue&type=script&lang=js&"
export * from "./CustomerDocumentationVerification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b92742d",
  null
  
)

export default component.exports